// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__o8HcI","screen":"style_screen__l8ydV"};